const MCQCards = [
  {
    id: 1,
    title: "MCQ on Blockchain & Cryptocurrency",
    description:
      "These are multiple choice questions that are designed to be a review for the exam.",
    difficulty: "Easy",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/BlockChain",
  },
  {
    id: 2,
    title: "MCQ on Computer Forensics",
    description:
      "Test your knowledge of computer forensics with these review questions.",
    difficulty: "Medium",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/Computer",
  },
  {
    id: 3,
    title: "MCQ on Cloud Forensics",
    description:
      "Prepare for cloud forensics challenges with this set of questions.",
    difficulty: "Hard",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/Cloud",
  },
  {
    id: 4,
    title: "MCQ on Database Forensics",
    description:
      "Enhance your knowledge of database forensics with these targeted questions.",
    difficulty: "Medium",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/Database",
  },
  {
    id: 5,
    title: "MCQ on Data Recovery Forensics",
    description:
      "These questions cover data recovery techniques and their forensic applications.",
    difficulty: "Easy",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/DataRecovery",
  },
  {
    id: 6,
    title: "MCQ on Drone Forensics",
    description:
      "Learn about drone forensics through these specialized questions.",
    difficulty: "Hard",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/Drone",
  },
  {
    id: 7,
    title: "MCQ on Email Forensics",
    description:
      "Understand email forensics with this set of review questions.",
    difficulty: "Medium",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/Email",
  },
  {
    id: 8,
    title: "MCQ on Gaming Forensics",
    description:
      "Test your knowledge of gaming forensics with these unique questions.",
    difficulty: "Easy",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/Gaming",
  },
  {
    id: 9,
    title: "MCQ on IoT Forensics",
    description: "Explore IoT forensics with these challenging questions.",
    difficulty: "Hard",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/Iot",
  },
  {
    id: 10,
    title: "MCQ on Malware Forensics",
    description:
      "Prepare for malware forensics scenarios with these multiple-choice questions.",
    difficulty: "Medium",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/Malware",
  },
  {
    id: 11,
    title: "MCQ on Mobile Forensics",
    description:
      "Get ready for mobile forensics challenges with these targeted questions.",
    difficulty: "Easy",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/Mobile",
  },
  {
    id: 12,
    title: "MCQ on Multimedia Forensics",
    description:
      "Dive into multimedia forensics with these specialized questions.",
    difficulty: "Medium",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/Multimedia",
  },
  {
    id: 13,
    title: "MCQ on Network Forensics",
    description:
      "Understand network forensics through these detailed questions.",
    difficulty: "Hard",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/Network",
  },
  {
    id: 14,
    title: "MCQ on Social Media Forensics",
    description:
      "Learn about social media forensics with this set of questions.",
    difficulty: "Easy",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/SocialMedia",
  },
  {
    id: 15,
    title: "MCQ on Vehicle Forensics",
    description:
      "Prepare for vehicle forensics with these insightful questions.",
    difficulty: "Medium",
    image: require("../../assets/img/DigitalForensics/Email.jpg"),
    link: "/Digital_Forensics/MCQ/Vehicle",
  },
];

export default MCQCards;
